/* Killer Golf — Easify → xo cart-drawer sync bridge
 *
 * Problem (2026-07-16): on products with Easify Product Options, Easify attaches its
 * own click handler to the add-to-cart button and performs the add via its OWN
 * `fetch POST /cart/add` (Accept: application/json, no theme `sections` param), calling
 * stopImmediatePropagation so the xo theme's addCart flow never runs. The server cart is
 * updated correctly, but xo's reactive store (window.xoStore['xo-cart']) is never told,
 * so the cart drawer — which renders from that store — stays empty until a full page
 * reload. Symptom: "I add to cart and nothing shows; refresh and it's there."
 *
 * Fix: detect an add that xo will NOT reflect (a successful POST /cart/add whose response
 * carries no rendered `sections`), then pull the freshly-rendered cart-mini section from
 * the Section Rendering API and push it into xoStore exactly like xo's own addCartSuccess
 * would — then open the drawer, matching the theme's normal add UX.
 *
 * xo's own native add (the cold-start path handled by [kg-easify-gate]) DOES return
 * `sections`, so this bridge no-ops on it → no double render, no double open.
 *
 * Depends on theme globals exposed by xo-webcomponents.js: window.xoStore, window.xoModal.
 * Marker: [kg-easify-cart-sync].
 */
(function () {
  if (window.__kgEasifyCartSync) return;
  window.__kgEasifyCartSync = 1;

  var MARK = '[kg-easify-cart-sync]';
  /* The Cart-mini component's id (<xo-cart-mini id="xo-cart-mini">) is the store-section
     key xo subscribes to; getServiceSections() renders exactly this off /cart pages. */
  var CART_MINI_ID = 'xo-cart-mini';

  var syncing = false;
  var lastSyncAt = 0;

  function log() {
    try { var a = [].slice.call(arguments); a.unshift(MARK); console.log.apply(console, a); } catch (_) {}
  }

  function syncDrawer(reason) {
    var now = Date.now();
    if (syncing) return;
    if (now - lastSyncAt < 250) return; /* collapse bursts (event + fetch both firing) */
    if (!window.xoStore || typeof window.xoStore.set !== 'function') return;
    syncing = true;
    lastSyncAt = now;

    Promise.all([
      fetch('/?sections=' + CART_MINI_ID, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); }),
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
    ]).then(function (res) {
      var sections = res[0] || {};
      var cart = res[1] || {};
      var html = sections[CART_MINI_ID];
      if (typeof html !== 'string') { syncing = false; return; }

      window.xoStore.set('xo-cart', function (prev) {
        var nextSections = {};
        if (prev && prev.sections) { for (var k in prev.sections) nextSections[k] = prev.sections[k]; }
        nextSections[CART_MINI_ID] = html;
        var next = {};
        for (var p in prev) next[p] = prev[p];
        next.sections = nextSections;
        next.size = cart.item_count;
        next.isAdded = true;
        return next;
      })('kg-easify-cart-sync');

      log('synced (' + reason + ') item_count=' + cart.item_count);
      try { if (window.xoModal && typeof window.xoModal.open === 'function') window.xoModal.open('cart'); } catch (_) {}
      syncing = false;
    }).catch(function (e) {
      log('sync failed:', e && e.message);
      syncing = false;
    });
  }

  /* Trigger: a POST /cart/add that xo will not reflect (response has no rendered sections).
     Easify's add is a window.fetch call, so this wrapper sees it. */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = _fetch.apply(this, arguments);
    if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        try {
          res.clone().json().then(function (data) {
            var hasSections = data && data.sections && typeof data.sections === 'object' && Object.keys(data.sections).length > 0;
            if (!hasSections) syncDrawer('cart-add-without-sections');
          }).catch(function () {});
        } catch (_) {}
      }).catch(function () {});
    }
    return p;
  };

  log('bridge installed');
})();
